//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TooltipIcon from '~/components/common/TooltipIcon.vue';

export default {
  components: {
    TooltipIcon,
  },
  props: {
    highlights: {
      type: Array,
      required: true,
    },
  },
};
